/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyCountInfo } from './EvmDailyCountInfo';

export type HumanityHomeDailyAccountCreatedInfo = {
    PTCACNT: string;
    CNGP: string;
    TRXHTP: HumanityHomeDailyAccountCreatedInfo.TRXHTP;
    DCALIST: Array<EvmDailyCountInfo>;
};

export namespace HumanityHomeDailyAccountCreatedInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

